<template>
  <table class="table table-striped table-bordered table-condensed">
    <thead v-if="headers">
      <tr>
        <th class="Center_content" style="width:100px;">{{headers[0]}}</th>
        <th class="Center_content text_overflow">{{headers[1]}}</th>
      </tr>
    </thead>
    <tbody>
      <template v-for="row in rows">
        <tr style="background-color:#fff">
          <td class="Center_content" style="width:100px;">
            <span v-if="row.children" class="details details-close" @click="communityDetails($event)"></span>
          </td>
          <td>{{row.description}}</td>
        </tr>
        <tr style="display:none">
          <td v-if="row.children" colspan="2">
            <tree-table :rows="row.children"></tree-table>
          </td>
        </tr>
      </template>
    </tbody>
  </table>
</template>

<script>
// import { mapState } from 'vuex'
// import http from '../../lib/utils/request.js'
import mixins from '../../mixins/index'
import { MSG_ID } from '../../lib/constant'

export default {
  name: 'treeTable',
  mixins: mixins,
  data () {
    return {
      isShow: false
    }
  },
  methods: {
    detail (id) {
      window.emitter.emit(MSG_ID.MSG_SYS_NAVIGATION_PUSH, { path: 'appdetail', query: { appId: id } })
    },
    communityDetails (el) {
      let $target = window.$(el.target).closest('tr').next()
      let $N_F = window.$(el.target).closest('span')
      if ($target.is(':hidden')) {
        /* this row default is close and hide - open and show it */
        $target.show()
        $N_F.addClass('details-open').removeClass('details-close')
        // this.communityDetail = !this.communityDetail
      } else {
        /* Close and hide this row */
        $target.hide()
        $N_F.addClass('details-close').removeClass('details-open')
        // this.communityDetail = !this.communityDetail
      }
    }
  },
  mounted () {

  },
  props: {
    headers: Array,
    rows: Array
  }
}
</script>
<style scoped>
.pager {
  margin: 0 auto;
}

.Center_content {
  text-align: center;
}

.details {
  display: inline-block;
  cursor: pointer;
  width: 15px;
  height: 15px;
}

.details-open {
  background: url(../../assets/datatable-row-openclose.png) no-repeat 0 31%;
}

.details-close {
  background: url(../../assets/datatable-row-openclose.png) no-repeat 0 -2%;
}
</style>


// WEBPACK FOOTER //
// TreeTable.vue?198252b3